var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "multiselect-page" },
    [
      _c("side-bar", { attrs: { "is-multi-select": true } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "multiselect-main-container" },
        [
          _c(
            "multiselect-table",
            {
              attrs: {
                layer: _vm.multiSelectData.layers[_vm.activeTab].layer,
                "lists-are-loaded": _vm.listsAreLoaded,
                "multi-select-data": _vm.multiSelectData
              },
              on: {
                closureDelete: function($event) {
                  _vm.closureDelete = $event
                },
                setObjectCount: function($event) {
                  _vm.objectCount = $event
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "header",
                  attrs: { slot: "header" },
                  slot: "header"
                },
                [
                  _c("div", [
                    _c("h2", { staticClass: "management-section-title" }, [
                      _vm._v("MULTISELECT")
                    ]),
                    _vm._v(" "),
                    _c("h4", [_vm._v("Objects: " + _vm._s(_vm.objectCount))])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "buttons-container" },
                    [
                      _c(
                        "management-button",
                        {
                          attrs: {
                            type: "execute",
                            label: _vm.$t("Export"),
                            disabled: _vm.numberSelectedObjects === 0,
                            align: "left"
                          },
                          on: { buttonClick: _vm.exportData }
                        },
                        [_c("v-icon", [_vm._v("download")])],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "management-button",
                        {
                          attrs: {
                            type: "execute",
                            label: _vm.$t("Save"),
                            disabled: _vm.saveButtonIsDisabled,
                            align: "left"
                          },
                          on: { buttonClick: _vm.saveData }
                        },
                        [_c("v-icon", [_vm._v("save")])],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _vm.multiSelectData.layers.length > 0
            ? _c("tabs", {
                attrs: {
                  tabs: _vm.tabs,
                  "active-tab": _vm.activeTab,
                  "translate-labels": true,
                  "tabs-styling": _vm.tabsStyling
                },
                on: {
                  startTabChange: function($event) {
                    _vm.activeTab = $event
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("multiselect-toolbar", {
        attrs: {
          layer: _vm.multiSelectData.layers[_vm.activeTab].layer,
          "closure-delete": _vm.closureDelete
        },
        on: {
          closeDialogDeleteClosure: function($event) {
            _vm.closureDelete.dialogOpen = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-65a2a66a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65a2a66a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/MultiSelect.vue
// module id = null
// module chunks = 